export default __webpack_public_path__ + "static/media/nftimg1.b55ee3a8.png";